<template>
  <div
    :class="['display-flex flex-items-start flex-content-between', { 'with-border-bottom': !isLast }]"
    :style="componentStyle"
  >
    <div
      v-if="isRequired"
      class="display-flex flex-items-start"
      style="gap: var(--spacing-3xs)"
    >
      <font-awesome-icon
        :icon="$v7.solid.faLock"
        class="padding-x-6xs margin-top-5xs"
      />
      <div>
        <strong>{{ title }}</strong>
        <p
          v-if="isShowingDescription"
          class="margin-top-4xs margin-bottom-sm"
        >
          {{ description }}
        </p>
      </div>
    </div>
    <div
      v-else
      class="display-flex flex-items-start"
      style="gap: var(--spacing-xs)"
    >
      <input
        :id="`cookies-${titleKebabCased}`"
        :checked="isChecked"
        type="checkbox"
        class="with-icon"
        @change="checkboxChanged"
      />
      <label
        :for="`cookies-${titleKebabCased}`"
        class="margin-0"
        :style="labelStyle"
      >
        <span class="position-relative">
          <font-awesome-icon
            :icon="$v7.regular.faSquare"
            size="lg"
            class="unchecked-icon"
            style="color: var(--icon-color); cursor: var(--input-cursor)"
          />
          <font-awesome-icon
            :icon="$v7.regular.faSquare"
            size="lg"
            class="hover-icon"
            style="color: var(--icon-color); cursor: var(--input-cursor)"
          />
          <font-awesome-icon
            :icon="$v7.solid.faSquareCheck"
            size="lg"
            class="checked-icon"
          />
        </span>

        <div>
          <strong>{{ title }}</strong>
          <p
            v-if="isShowingDescription"
            class="margin-top-4xs margin-bottom-sm"
          >
            {{ description }}
          </p>
        </div>
      </label>
    </div>

    <button
      class="link flat secondary compact margin-0 padding-y-0"
      style="--link-color: var(--fa-dk-blue); --link-hover-color: var(--fa-blue)"
      @click.prevent="$emit('showCookieDescription', title)"
    >
      <font-awesome-icon :icon="$v7.solid.faCircleInfo" />
    </button>
  </div>
</template>

<script>
  import { kebabCase } from 'lodash'

  export default {
    name: 'CustomizeCookiesCheckbox',

    props: {
      description: {
        type: String,
        required: true
      },
      isChecked: {
        type: Boolean,
        required: true
      },
      isLast: {
        type: Boolean,
        default: false
      },
      isRequired: {
        type: Boolean,
        required: true
      },
      isShowingDescription: {
        type: Boolean,
        required: true
      },
      title: {
        type: String,
        required: true
      }
    },

    computed: {
      componentStyle() {
        let style = {}

        style['gap'] = 'var(--spacing-md)'

        if (!this.isLast) {
          style['--hr-border-color'] = 'var(--fa-dk-yellow)'
          style['--hr-border-style'] = 'dotted'
          style['--hr-border-width'] = 'var(--border-width-xs)'
        }

        return {
          ...style
        }
      },

      labelStyle() {
        let style = {}

        style['--label-display'] = 'flex'
        style['gap'] = 'var(--spacing-3xs)'

        if (!this.isRequired) {
          style['cursor'] = 'pointer'
        }

        return {
          ...style
        }
      },

      titleKebabCased() {
        return kebabCase(this.title)
      }
    },

    methods: {
      checkboxChanged(event) {
        this.$emit('change', event.srcElement.checked)
      }
    }
  }
</script>
